import * as React from 'react';
import { getLinks, userSession } from 'state/session';
import Button from 'components/Button';
import { classNames } from 'utils/ui/css';
import { showToast } from 'state/toast';
import { t } from '@lingui/core/macro';
import { analyticsState } from 'state/analytics';
import Icon from 'components/Icon';
import logger from 'utils/log';
import { writeTextToClipboard } from 'utils/clipboard';

export const copyLink = (e: React.MouseEvent) => {
  e.preventDefault();
  const { customerStreamUrl } = getLinks();

  writeTextToClipboard(customerStreamUrl).then((result) => {
    if (result.success) {
      showToast({ title: t`Link copied to clipboard`, type: 'success', notificationId: 'COPY_LINK_SUCCESS' });
      analyticsState().setValues({ dealerToolUsed: 'copyUrl' });
    } else {
      showToast({
        title: t`Could not copy URL`,
        message: result.error?.message || 'Unknown error',
        type: 'error',
        notificationId: 'COPY_LINK_ERROR',
      });
      logger.error('Could not copy URL: ', result.error);
    }
  });
};

type TCopySharingLinkButton = {
  className?: string;
  showSeparator?: boolean;
} & Omit<React.ComponentProps<typeof Button>, 'onClick' | 'icon' | 'className'>;

const CopySharingLinkButton: React.FC<TCopySharingLinkButton> = ({
  showSeparator = true,
  svgClassName,
  className,
  ...buttonProps
}) => {
  const session = userSession().useState();

  const shouldShowButton = session.sharingType === 'remote';

  return (
    <>
      {shouldShowButton && (
        <>
          <Button
            className={classNames(className)}
            svgClassName={classNames(svgClassName, 'size-6')}
            icon="ex3d-icon--share"
            part="header-button--share"
            onClick={copyLink}
            {...buttonProps}
          />
          {showSeparator && <Icon className="ex3d-icon--line ml-0 size-6 bg-white" />}
        </>
      )}
    </>
  );
};

export default CopySharingLinkButton;
